import { render, staticRenderFns } from "./zxg.vue?vue&type=template&id=18016cb9&scoped=true&"
import script from "./zxg.vue?vue&type=script&lang=js&"
export * from "./zxg.vue?vue&type=script&lang=js&"
import style0 from "./zxg.vue?vue&type=style&index=0&id=18016cb9&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18016cb9",
  null
  
)

export default component.exports